import React, { useEffect, useState } from "react";

import "./ServiceCentreSerachActionsStyles.scss";
import { Expander } from "components/generic/ExpandableSections/Expander";
import { Button } from "react-bootstrap";
import { FormikField } from "components/generic/FormikField";
import { RadioButtonProps } from "components/generic/RadioButton";
import { RadioButtonGroup } from "components/generic/RadioButtonGroup";
import { AdditionalServiceType, SiteTypeFilter } from "generated/types/types"
import { CheckBox } from "components/generic/CheckBox"
import { useTranslation } from "react-i18next";

interface Props {
    showHiddenSites : boolean;
    WorkType: AdditionalServiceType;
    handleShowHiddenSites : () =>void;
    refineOnClick: () => void;
    goToPreviousStep: () => void;
    setFieldValue: (field: string, value: string | number | SiteTypeFilter | boolean) => void;
    onFilterExpand: (isExpanded: boolean) => void;
    showServiceCenterNameGarageSearchFilter: boolean;
    showSiteTypeGarageSearchFilter: boolean;
    showSearchRadiusGarageSearchFilter: boolean;
    showMainDealerGarageSearchFilter: boolean;
    safetyRecall: boolean
}

export const ServiceCentreSearchActions: React.FC<Props> = (props: Props) => {
    const resetFiltersHandler = () => {
        props.setFieldValue("siteName", "");
        props.setFieldValue("searchRadius", "");
        props.setFieldValue("siteTypeRestriction", SiteTypeFilter.All);
        props.setFieldValue("isMainDealer", false)

        sessionStorage.setItem("isMainDealer", JSON.stringify(false));
        sessionStorage.setItem("siteName", "");
        sessionStorage.setItem("siteTypeRestriction", SiteTypeFilter.All)
        sessionStorage.setItem("searchRadius", "");
    };
    const [filtersExpanded, setFiltersExpanded] = useState<boolean>(false);
    const filtersExpandedState = {
        isExpanded: filtersExpanded,
        setIsExpanded: setFiltersExpanded,
    };
    const handleExpand = () => {
        setFiltersExpanded(!filtersExpanded);
        props.onFilterExpand(!filtersExpanded);
    };
    
    const { t } = useTranslation();

    const mobileGarageFilterOptions: RadioButtonProps[] = [
        { label: t("service_center_all"), value: SiteTypeFilter.All },
        { label: t("service_center_mobile_only"), value: SiteTypeFilter.Mobile },
        { label: t("service_center_exclude_mobile"), value: SiteTypeFilter.Fixed },
    ];

    if (!props.showServiceCenterNameGarageSearchFilter && !props.showSiteTypeGarageSearchFilter && !props.showSearchRadiusGarageSearchFilter && !props.showMainDealerGarageSearchFilter) {
        return null;
    }
    return (
        <div className="col-12">
            <div className="search-actions">
                <div className="service-centre-search-action" onClick={handleExpand}>
                    {filtersExpanded ?
                        <div>{t("service_center_close_search")}<span className="close-text-sub-title">{t("service_center_close_select_new_search")}</span></div>
                        : t("service_center_close_refine_search")}
                </div>
                {props.showHiddenSites &&  props.WorkType === AdditionalServiceType.Delivery && (
                <div
                    className="service-centre-search-action"
                    onClick={props.handleShowHiddenSites}
                >
                    {t("service_center_show_hidden")}
                </div>
            )}          
            </div>
            <Expander
                borderWidthCorrection={3}
                isExpandedState={filtersExpandedState}
                containerClassName="search-actions-container"
                innerContainerClassName="inner-search-actions-container"
            >
                {props.showServiceCenterNameGarageSearchFilter &&
                    <div className="col-sm-3 filter">
                        <FormikField name="siteName" label={t("service_center_search_garage_name")} type="text" />
                    </div>
                }
                {(() => {
                    if (!props.showSearchRadiusGarageSearchFilter && !props.showMainDealerGarageSearchFilter) return null;

                    return <div className="col-sm-2 filter">
                        {props.showSearchRadiusGarageSearchFilter &&
                            <>
                                <div className="inline-search-radius">
                                    <FormikField name="searchRadius" label={t("service_center_search_search_radius")} type="number" />
                                    <br></br>
                                </div>
                            </>}
                    </div>;
                })()}
                {props.showSiteTypeGarageSearchFilter && (
                    <div className="col-sm-4 filter site-type-field">
                        <label className="col-form-label site-type-label radio-group">{t("service_center_search_site_type")}</label>
                        <div className="radio-group">
                            <RadioButtonGroup
                                name="siteTypeRestriction"
                                radioButtonValues={mobileGarageFilterOptions}
                                orientation="horizontal"
                            />
                        </div>
                    </div>

                )}
                {(() => {

                    if (!props.showMainDealerGarageSearchFilter) return null;

                    return (
                        <div className="col-sm-2 filter">
                            <CheckBox name="isMainDealer" className="check-box-label">{t("service_center_search_main_dealer")}</CheckBox>
                        </div>
                    );
                })()}
                <div className="col-12 filter-actions-container">
                    <div className="reset-filters" onClick={resetFiltersHandler}>
                        {t("service_center_search_reset_filters")}
                    </div>
                    <div className="refine-button">
                        <Button size="lg" onClick={props.refineOnClick}>
                            {t("service_center_search_refine_button")}
                        </Button>
                    </div>
                </div>
            </Expander>
        </div>
    );
};